import { render, staticRenderFns } from "./CardCenario.vue?vue&type=template&id=245c85fe&"
import script from "./CardCenario.vue?vue&type=script&lang=js&"
export * from "./CardCenario.vue?vue&type=script&lang=js&"
import style0 from "./CardCenario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports